/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { AutoSizer, Grid, MultiGrid } from 'react-virtualized';

import Tappable from 'app/components/commons/Tappable';
import { getGames } from '../util';
import GameLogCell from './GameLogCell';
import GameLogHeading from './GameLogHeading';
import NoHistory from './NoHistory';

type Props = {
  fixedColumnCount?: number,
  headerRowCount?: number,
  isRacing?: boolean,
  player: *,
  rowHeight?: number
};

type State = {
  expandedIndex: ?number
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  fontSize: theme.fontSize.tiny,
  fontWeight: '300',
  flexGrow: 1,
  overflow: 'auto',
  width: '100%',
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    height: 270
  }
}));

Grid.defaultProps.overscanColumnCount = 100; // HACK

class GameLog extends React.Component<Props, State> {
  props: Props;

  state: State = {
    expandedIndex: null
  };

  static defaultProps = {
    fixedColumnCount: 2,
    headerRowCount: 1,
    isRacing: false,
    rowHeight: 32
  };

  componentDidUpdate(prevProps, prevState) {
    const { expandedIndex } = this.state;

    if (prevState.expandedIndex !== expandedIndex) {
      // [MC] bit of a hack I think, can't work out how else to update the expanded rows though...
      // react-virtualized pure components can be hard to break
      if (
        this.multiGrid.current &&
        typeof this.multiGrid.current.recomputeGridSize === 'function'
      ) {
        try {
          this.multiGrid.current.recomputeGridSize();
        } catch (err) {
          // do nothing
        }
      }
    }
  }

  multiGrid = React.createRef();

  onHeaderClick(index) {
    this.setState(state => ({ expandedIndex: state.expandedIndex === index ? null : index }));
  }

  render() {
    const { fixedColumnCount, headerRowCount, isRacing, rowHeight, player } = this.props;
    const { expandedIndex } = this.state;
    const categoriesCount = player.categories.length;
    const gamesCount = player.games.length;
    const games = getGames(player);
    const rowCount = headerRowCount + gamesCount;

    if (gamesCount === 0) {
      return <NoHistory name={player.name} />;
    }

    const colWidth = isRacing ? 100 : 60;
    const windowHeight = (rowCount + 1) * rowHeight;

    return (
      <Wrapper>
        <MultiGrid
          ref={this.multiGrid}
          cellRenderer={({ key, rowIndex, columnIndex, ...cellProps }) =>
            rowIndex === 0 ? (
              <Tappable
                component={GameLogHeading}
                key={key}
                onTap={() => {
                  this.onHeaderClick(columnIndex);
                }}
                expanded={expandedIndex === columnIndex}
                categories={player.categories}
                columnIndex={columnIndex}
                isRacing={isRacing}
                {...cellProps}
              />
            ) : (
              <GameLogCell
                key={key}
                game={games[rowIndex - 1]}
                categories={player.categories}
                columnIndex={columnIndex}
                isRacing={isRacing}
                {...cellProps}
              />
            )
          }
          columnCount={fixedColumnCount + categoriesCount}
          columnWidth={({ index }) => (expandedIndex === index ? 100 : colWidth)}
          fixedColumnCount={fixedColumnCount}
          fixedRowCount={headerRowCount}
          height={windowHeight}
          rowCount={rowCount}
          rowHeight={rowHeight}
          width={435}
        />
      </Wrapper>
    );
  }
}

export default GameLog;
